<template>
  <div class="base-control base-progress form-group row">
    <label class="col-sm-4" :class="{'col-form-label': inline}">{{ label }}</label>
    <div class="col-sm-8 d-flex align-items-center">
      <div class="d-inline-block percentage-number" style="width: 70px;">{{ value }}%</div>
      <div class="d-inline-block position-relative progress-container">
        <div class="progress" :class="{overflow: overflow}" :style="{width: value + '%'}"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'BaseProgress',
  props: {
    value: {
      type: Number,
      default: 0
    },
    label: {
      type: String,
      default: ''
    },
    inline: {
      type: Boolean,
      default: true
    },
    styleType: {
      type: String,
      default: ''
    }
  },
  computed: {
    id () {
      return 'base-progress-' + this._uid;
    },
    overflow () {
      return this.value > 100;
    }
  },
  methods: {

  }
};

</script>

<style>
</style>
